module.exports = __webpack_public_path__ + "static/img/temperature_1.f5e1e6be.svg";